<template>
  <v-input
    v-bind="$attrs"
    v-on="$listeners"
    v-model="localValue"
    class="base-input-select"
  >
    <template #prepend-inner>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="container-select"
            v-bind="!isReadonly ? attrs : ''"
            v-on="!isReadonly ? on : null"
          >
            <template v-if="selected">
              <template v-if="selected.img">
                <simple-svg
                  :src="require(`@/assets/${selected.img}.svg`)"
                  width="16px"
                />
              </template>
              <template v-else>
                <span style="font-size: 12px">
                  {{ selected.label }}
                </span>
              </template>
            </template>
            <v-icon size="16" class="ml-1">mdi-chevron-down</v-icon>
          </div>
        </template>
        <v-list
          flat
          max-height="200"
          class="options-select"
          :class="{
            dark: $vuetify.theme.dark,
          }"
        >
          <v-list-item
            v-for="(item, index) in options"
            :key="index"
            dark
            @click="handleSelect(item)"
          >
            {{ item.label }}
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-for="(slotContent, slotName) in slots" v-slot:[slotName]>
      <slot :name="slotName">{{ slotContent(slotProps) }}</slot>
    </template>
  </v-input>
</template>

<script>
export default {
  name: 'BaseInputSelect',
  data() {
    return {
      localValue: '',
      selected: {},
    }
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    slots() {
      if (this.$slots.hasOwnProperty('label')) delete this.$slots.label
      return this.$slots
    },
    isReadonly() {
      if (this.$attrs.hasOwnProperty('readonly')) return true
      return false
    },
  },
  mounted() {
    this.selected = this.options[0]
  },
  methods: {
    handleSelect(item) {
      this.selected = item
    },
  },
  watch: {
    value(val) {
      this.localValue = val
    },
    localValue(val) {
      this.$emit('input', val)
    },
    selected(val) {
      this.$emit('selectionUpdated', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.base-input-select {
  &::v-deep {
    .v-input__prepend-inner {
      margin: 0 !important;
      padding: 0;
      min-height: inherit;
    }

    .container-select {
      border-radius: 3px;
      border-end-end-radius: 0;
      border-start-end-radius: 0;
      background: varFigma(neutral-99);
      border: 1px solid varFigma(neutral-95-lightest);
      display: flex;
      align-items: center;
      z-index: 2;
      min-width: 52px;
      padding: 8px;

      &:hover {
        border: 1px solid varFigma(brand-80-light);
      }
    }

    .v-input__slot {
      padding: 0 !important;
    }

    input {
      padding-left: 12px;
      padding-right: 12px;
    }
    &.v-input--is-readonly {
      .container-select {
        background: transparent;
        border-color: transparent;
        color: varFigma(neutral-60) !important;

        i {
          opacity: 0;
        }
      }
    }

    &.error--text {
      .container-select {
        border: 1px solid varFigma(feedback-danger-light) !important;
        i.v-icon {
          color: varFigma(feedback-danger-dark) !important;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.options-select {
  &.dark {
    .v-list-item {
      background-color: var(--v-neutral-darken2);
      color: var(--v-neutral-lighten4) !important;
    }
  }

  .v-list-item {
    background-color: #fff;
    color: var(--v-neutral-darken2) !important;
    min-height: 32px;
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>
